import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from "formik";
import * as Yup from "yup";

import messages from '../../../assets/locale/messages';
import Input from "../../../components/Input";
import Modal from "../../../components/Modal";
import { editServiceRequest, editServiceBulkRequest } from '../../../store/Services/actions';

const RejectRequestModal = ({
    open,
    setOpen,
    isBulkSelection,
    selectedSingleCard,
    selectedCards,
    setSelectedCards,
    setSelectedSingleCard,
    setIsBulkSelection,
    onsuccess
}) => {
    const lang = useSelector((state) => state.locale.lang);
    const isEnglish = lang === 'en';
    const { lookupsRequests, shared } = messages[lang];
    const dispatch = useDispatch();
    const form = useFormik({
        initialValues: { reason: "" },
        validationSchema: Yup.object({
            reason: Yup.string().trim().required('required')
        }),
        onSubmit: async ({ reason }) => {
            if (isBulkSelection) {
                dispatch(
                    editServiceBulkRequest({
                        ids: selectedCards,
                        status: 'rejected',
                        rejection_reason: reason.trim()
                    }
                        , () => {
                            setOpen(false);
                            setSelectedCards([]);
                            setSelectedSingleCard(null);
                            onsuccess();
                        })
                );
            } else {
                dispatch(
                    editServiceRequest({
                        id: +selectedSingleCard.id,
                        data: {
                            status: 'rejected',
                            rejection_reason: reason.trim()
                        },
                    }
                        , () => {
                            setOpen(false);
                            setSelectedSingleCard(null);
                            onsuccess();
                        })
                    );
                }
                setIsBulkSelection(false);
                resetForm();
        }
    });

    const { values, handleSubmit, setFieldTouched, setFieldValue, touched, errors, resetForm } = form;

    const renderRejectRequestModelContent = () => (
        <form onSubmit={handleSubmit}>
            <Input
                id="reason"
                name="reason"
                type="text"
                label={lookupsRequests.rejectModal.contentText}
                placeholder={lookupsRequests.rejectModal.placeholder}
                required
                value={values["reason"]}
                onChange={(value) => {
                    setFieldTouched("reason");
                    setFieldValue("reason", value);
                }}
                labelClassName="text-dark font-medium mb-2"
                isInputHasErr={!!(touched["reason"] && errors["reason"])}
                errMsg={errors["reason"]}
            />
        </form>
    );

    const onCancelOrClose = () => {
        resetForm({
            values: {
                reason: "",
            }
        });
        setOpen(false);
    };

    return (
        <Modal
            open={open}
            handleClose={onCancelOrClose}
            title={lookupsRequests.rejectModal[isBulkSelection ? 'bulkTitle' : 'singleTitle']}
            contentClass="mb-5 pb-2 text-primary"
            content={renderRejectRequestModelContent()}
            confirmBtnTxt={shared.confirm}
            maxWidth="xs"
            cancelBtnTxt={shared.cancel}
            isContentText={false}
            handleConfirm={handleSubmit}
            handleCancel={onCancelOrClose}
            modalClass="delete-services-modal"
            actionsClass="container px-4"
            confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
            cancelBtnClass="fsize-14 py-2 text-secondary"
            disableActionBtn={!!(!touched["reason"] || errors["reason"])}
        />
    )
};

export default RejectRequestModal;